import React from 'react';
import PropTypes from 'prop-types';
import ShoppingCartDetails from './shoppingCartDetails';
import ShoppingCartSummary from './shoppingCartSummary';

function ShoppingCart({
  recurringPrices,
  oneTimePrices,
  totalOneTimePrice,
  totalRecurringPrice,
  taxShortName,
  isTaxChanged,
}) {
  return (
    <div className="shopping-cart" data-cy="shopping-cart">
      <div className="shopping-cart__details" data-cy="shopping-cart__details">
        <ShoppingCartDetails
          recurringPrices={recurringPrices}
          oneTimePrices={oneTimePrices}
        />
      </div>
      <div className="shopping-cart__summary" data-cy="shopping-cart__summary">
        <ShoppingCartSummary
          totalOneTimePrice={totalOneTimePrice}
          totalRecurringPrice={totalRecurringPrice}
          isTaxChanged={isTaxChanged}
          taxShortName={taxShortName}
        />
      </div>

      <style jsx>
        {`
          .shopping-cart {
            border: 1px solid var(--color-gp--grey3);
            border-radius: 4px;
            .shopping-cart__details {
              padding: 16px;
              background: var(--color-gp--white);
              border-top-left-radius: 4px;
              border-top-right-radius: 4px;
            }
            .shopping-cart__summary {
              padding: 16px;
              background: var(--color-gp--grey2);
              border-bottom-left-radius: 4px;
              border-bottom-right-radius: 4px;
            }
          }
        `}
      </style>
    </div>
  );
}
ShoppingCart.propTypes = {
  taxShortName: PropTypes.string.isRequired,
  isTaxChanged: PropTypes.bool,
  recurringPrices: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      price: PropTypes.number,
      promoted: PropTypes.bool,
      promotionText: PropTypes.string,
      promotionPrice: PropTypes.number,
    })
  ),
  oneTimePrices: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      price: PropTypes.number,
      promoted: PropTypes.bool,
    })
  ),
  totalOneTimePrice: PropTypes.shape({
    name: PropTypes.string,
    price: PropTypes.number,
  }),
  totalRecurringPrice: PropTypes.shape({
    name: PropTypes.string,
    price: PropTypes.number,
    promoted: PropTypes.bool,
    promotionText: PropTypes.string,
    promotionPrice: PropTypes.number,
  }),
};

ShoppingCart.defaultProps = {
  recurringPrices: [],
  oneTimePrices: [],
  totalOneTimePrice: null,
  totalRecurringPrice: null,
  isTaxChanged: false,
};
export default ShoppingCart;
